import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-[1200px] w-full mx-auto">
        <h1 className="h1 text-text-dark mb-6">Termini e Condizioni di Utilizzo</h1>
        
        <p className="body text-text-dark mb-6">Ultimo aggiornamento: 23/04/2025</p>

        <section className="mb-8">
          <h2 className="h2 text-text-dark mb-4">1. Accettazione dei Termini</h2>
          <p className="body text-text-dark mb-4">
            Utilizzando il sito web alessandrafilzoli.com e i servizi ad esso collegati, l'utente accetta di essere vincolato dai seguenti termini e condizioni.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="h2 text-text-dark mb-4">2. Iscrizione ai Servizi</h2>
          <p className="body text-text-dark mb-4">
            Iscrivendosi ai nostri servizi, l'utente conferma che l'indirizzo email fornito è di sua proprietà e che tutte le informazioni fornite sono veritiere e accurate.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="h2 text-text-dark mb-4">3. Prenotazione e Cancellazione degli Appuntamenti</h2>
          <p className="body text-text-dark mb-4">
            Prenotando un appuntamento, l'utente si impegna a:
          </p>
          <ul className="list-disc list-inside body text-text-dark mb-4">
            <li>Fornire informazioni accurate e veritiere.</li>
            <li>Avvisare con almeno 24 ore di anticipo in caso di necessità di cancellazione o riprogrammazione dell'appuntamento.</li>
          </ul>
          <p className="body text-text-dark mb-4">
            In caso di mancato rispetto di queste condizioni, ci riserviamo il diritto di:
          </p>
          <ul className="list-disc list-inside body text-text-dark mb-4">
            <li>Contrassegnare l'indirizzo email dell'utente.</li>
            <li>Rifiutare future prenotazioni da parte dell'utente.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="h2 text-text-dark mb-4">4. Prodotti Digitali</h2>
          <h3 className="h3 text-text-dark mb-3">4.1 Tipologie di Prodotti</h3>
          <p className="body text-text-dark mb-4">
            Il nostro sito offre diversi tipi di prodotti digitali, tra cui e-book, videocorsi e audiolibri, acquistabili direttamente online.
          </p>
          
          <h3 className="h3 text-text-dark mb-3">4.2 Licenza d'Uso</h3>
          <p className="body text-text-dark mb-4">
            Con l'acquisto di un prodotto digitale, l'utente ottiene una licenza personale, non esclusiva e non trasferibile per accedere e utilizzare il contenuto acquistato, esclusivamente per uso personale e non commerciale.
          </p>
          
          <h3 className="h3 text-text-dark mb-3">4.3 Restrizioni sul Download</h3>
          <p className="body text-text-dark mb-4">
            L'utente può scaricare i contenuti digitali solo quando esplicitamente consentito attraverso gli appositi pulsanti o funzionalità di download messi a disposizione sul sito. Nel caso dei videocorsi, questi sono disponibili esclusivamente in modalità streaming e non è consentito il download, salvo quando diversamente specificato.
          </p>
          <p className="body text-text-dark mb-4">
            Il tentativo di scaricare contenuti utilizzando metodi non esplicitamente autorizzati dal venditore (come software di terze parti, estensioni del browser o altri strumenti di cattura) costituisce una violazione di questi Termini e Condizioni.
          </p>
          
          <h3 className="h3 text-text-dark mb-3">4.4 Durata dell'Accesso ai Videocorsi</h3>
          <p className="body text-text-dark mb-4">
            Ci riserviamo il diritto di mantenere attivo il servizio di streaming dei videocorsi per un minimo di sei mesi dalla data di lancio del videocorso stesso. Al termine di questo periodo, in base a decisioni interne, potremmo comunicare via email all'acquirente la rimozione del servizio online e, in tal caso, predisporremo un link per il download dei prodotti acquistati.
          </p>
          
          <h3 className="h3 text-text-dark mb-3">4.5 Violazione dei Termini</h3>
          <p className="body text-text-dark mb-4">
            Qualsiasi tentativo di aggirare le protezioni tecniche, di condividere l'accesso ai contenuti con terze parti non autorizzate o di utilizzare i contenuti per scopi commerciali costituisce una violazione di questi termini. In caso di violazione, ci riserviamo il diritto di revocare immediatamente l'accesso ai contenuti senza alcun rimborso e di intraprendere le azioni legali ritenute necessarie.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="h2 text-text-dark mb-4">5. Utilizzo Responsabile</h2>
          <p className="body text-text-dark mb-4">
            L'utente si impegna a utilizzare il sito e i servizi in modo responsabile e nel rispetto degli altri utenti e dello staff.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="h2 text-text-dark mb-4">6. Diritti di Proprietà Intellettuale</h2>
          <p className="body text-text-dark mb-4">
            Tutti i contenuti presenti sul sito e nei prodotti digitali, inclusi testi, grafica, loghi, immagini, audio, video e software, sono di proprietà di Alessandra Filzoli o dei suoi licenziatari e sono protetti dalle leggi sul diritto d'autore e sulla proprietà intellettuale.
          </p>
          <p className="body text-text-dark mb-4">
            È severamente vietato copiare, modificare, distribuire, trasmettere, visualizzare, riprodurre, pubblicare, concedere in licenza, creare opere derivate, trasferire o vendere qualsiasi informazione o contenuto ottenuto dal sito o dai prodotti digitali senza previa autorizzazione scritta.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="h2 text-text-dark mb-4">7. Politica di Rimborso</h2>
          <p className="body text-text-dark mb-4">
            Data la natura dei prodotti digitali, generalmente non offriamo rimborsi per gli acquisti effettuati, salvo nei casi previsti dalla legge o in circostanze eccezionali valutate caso per caso. Per richiedere un rimborso, contattare support@alessandrafilzoli.com specificando i dettagli dell'acquisto e il motivo della richiesta.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="h2 text-text-dark mb-4">8. Modifiche ai Termini</h2>
          <p className="body text-text-dark mb-4">
            Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. Le modifiche entreranno in vigore immediatamente dopo la pubblicazione sul sito.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="h2 text-text-dark mb-4">9. Contatti</h2>
          <p className="body text-text-dark mb-4">
            Per qualsiasi domanda riguardante questi termini e condizioni, contattare:
          </p>
          <p className="body text-text-dark mb-4">
          Alessandra Filzoli<br />
            Email: support@alessandrafilzoli.com<br />
            Indirizzo: Piazza San Vito 24, Lentate Sul Seveso, MB, Italia
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;